import type { CampaignFeatures } from "../types/campaign";

export const DEFAULT_FEATURES: CampaignFeatures = {
  showProspectList: true,
  showWebinarAttendees: false,
  showAdMetrics: true,
  showLinkedInAutomation: true,
  showConnectionRequests: true,
  showOutreachMessages: true,
  showMessageResponses: true,
  showEmailMetrics: true,
  showNewsletterData: true,
  showSocialMediaMetrics: true,
  showTwitterMetrics: true,
  showFacebookMetrics: true,
  showDatabaseQuery: false,
  showRealTimeData: true,
  showCSVExport: true,
  showAdvancedAnalytics: true,
};

export const WEBINAR_FEATURES: CampaignFeatures = {
  ...DEFAULT_FEATURES,
  showLinkedInAutomation: false,
  showConnectionRequests: false,
  showOutreachMessages: false,
  showMessageResponses: false,
  showFacebookMetrics: false,
  showAdvancedAnalytics: false,
};

export const SEARCH_ONLY_FEATURES: CampaignFeatures = {
  ...WEBINAR_FEATURES,
};
